import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const BellOutlineIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8 14.5c.73333 0 1.33333-.6 1.33333-1.3333H6.66667c0 .7333.6 1.3333 1.33333 1.3333Zm4-4V7.16667c0-2.04667-1.0867-3.76-3-4.21334V2.5c0-.55333-.44667-1-1-1s-1 .44667-1 1v.45333c-1.90667.45334-3 2.16-3 4.21334V10.5l-1.33333 1.3333V12.5H13.3333v-.6667L12 10.5Zm-1.3333.6667H5.33333V7.16667c0-1.65334 1.00667-3 2.66667-3s2.6667 1.34666 2.6667 3v4.00003ZM5.05333 2.55333 4.1 1.6C2.5 2.82 1.44667 4.7 1.35333 6.83333h1.33334c.1-1.76666 1.00666-3.31333 2.36666-4.28Zm8.25997 4.28h1.3334C14.5467 4.7 13.4933 2.82 11.9 1.6l-.9467.95333c1.3467.96667 2.26 2.51334 2.36 4.28Z" />
  </Icon>
);

export default memo(BellOutlineIcon);
